/* eslint-disable */
import React from 'react'
import cls from './seoIndex.module.sass'
import { Link } from 'react-router-dom'
import { openMenu } from '../../../store/common/commonSlice'
import { RootState } from '../../../store/rootReducer'
import { useDispatch, useSelector } from 'react-redux'

const RuSeoInfo = () => {
    const dispatch = useDispatch()
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    return (
        <div className={cls['page_desc']}>
            <p>
                Я Боб, создатель этого <strong>похотливого</strong> сайта, Я рад приветствовать Вас на Bob Voyeur, сайте
                для <strong>любителей</strong> со 100% <strong>любительским</strong> контентом.
            </p>
            <p>
                Bob Voyeur - это сайт <strong>для взрослых</strong> предназначенный для стриптизеров и вуайеристов.
                Более 6 лет тысячи <strong>парочек</strong>, похотливые девушки и парни доверяют мне и делятся их{' '}
                <strong>развратными видео</strong> и <strong>порно фото</strong> с миллионами вуайеристов
                привлекательным сексом во всех его формах.
            </p>
            <p>
                Сообщество Bob Voyeur - это крупнейшее развратное сообщество Интернета во Франции, ежедневные встречи
                тысяч развратников <strong>эксгибиционистов</strong>, извращение, вуайеризм,{' '}
                <strong>групповой секс</strong> и <strong>свингерство</strong>.
            </p>
            <p>
                Каждый день я получаю десятки подборок любителей которые посланы мне{' '}
                <strong>развратными парочками</strong>, <strong>похотливыми самцами</strong> или{' '}
                <strong>сексуальными девушками</strong> и я немедленно выкладываю их к наслаждению посетителей. Подборки
                фото и видео разложены по различным секциям сайта и очень большое количество в{' '}
                <strong>свободном доступе</strong>. Обворожительные ЛЕГКИЕ <strong>фото и видео</strong> меньше 30
                секунд публикуются в <strong>свободном</strong> Bob Voyeur.
            </p>
            <p>
                ГОРЯЧИЕ фото, длинные видео более 30 секунд, подборки по темам и архивы с самого открытия сайта
                публикуются в Premium. Вы также можете поделиться своими <strong>порно фото</strong> и{' '}
                <strong>развратным видео</strong> со всеми любителями порно в сообществе Боба. Регистрация{' '}
                <strong>бесплатна</strong>. В считаные минуты Вы можете загрузить Вашу подборку анонимно через страницу
                "<Link onClick={(event) => {if (!loggedIn) {
                event.preventDefault()
                dispatch(openMenu())
            }}} to="/ru/membre/submit">Загрузить Ваши фото</Link>" и написать текст своего объявления который позволит Вам
                незамедлительно начать контакт с тысячами парочек, парней и девушек которые оценят Вашу подборку и будте
                уверены захотят Вас узнать ;-)
            </p>
            <p>
                Самое важное для меня, то что <strong>привлекательные фото</strong> и <strong>эротическое видео</strong>{' '}
                посланные на Bob Voyeur подлинные и действительно <strong>любительские</strong>. Раздел "
                <a href="/ru/femmes-et-couples-certifies/">Подтвержденные любители</a>" включает несколько сотен
                любителей которые доказали их подлинность послав мне подтверждающее фото. Краденые фото и видео, плохое
                качество и отсутствие эстетики не публикуется. Только качественные <strong>эротичные подборки</strong>{' '}
                находятся на сайте весь день и наиболее сексуальные выбираются для раздела "
                <a href="/ru/les-meilleures-photos/">Лучшие фото</a>".
            </p>
            <p>
                Бесплатный email сервис позволяте Вам посылать сообщение <strong>любителям</strong> которые послали{' '}
                <strong>фото</strong> или сексуальное <strong>видео</strong> объявление. Просто зарегистрируйтесь
                бесплатно чтобы посылать сообщение и оставлять Ваши комментарии для парочек, девушке и парней по Вашему
                выбору. Вы можете присоединить Ваши фото и Ваше завлекающее персональное сообщение и начать делиться
                Вашими собственными <strong>порно фото</strong> и <strong>развратным видео</strong> с ними.
            </p>
            <p>
                Что бы Вы ни искали, удовлетворение, мечты или фантазии, Вы можете встретить пары, парней и девушек у
                которых есть что разделить с Вами. Сообщество Bob Voyeur предназначено для всех похотливых взрослых,
                развратников и включает все виды: <strong>разврат</strong>, <strong>свингерство</strong>,{' '}
                <strong>групповой секс</strong>, <strong>вуайеризм</strong> и <strong>эксгибиционизм</strong>. Вы можете
                учавствовать во всем, осуществить Ваши фантации и эротические встречи со смешанными парами и свингерами.
            </p>
            <p>Добро пожаловать в культовое место разврата, секса, эротики, фантазии, свингерства и порно.</p>
            <p>
                Если вы парень, Вам нравится показывать себя, Вы ищете других сексуальных парней или пару, Вы обязаны
                посетить версию Bob Voyeur для <strong>геев и трансвеститов</strong>. Мой сайт{' '}
                <a href="http://www.bob4men.com/" target="_blank" rel="noreferrer">
                    www.bob4men.com
                </a>{' '}
                предназначен парней, которые любят других <strong>голых парней</strong> ;-)
            </p>
            <p>
                И наконец, если Вы хотите пойти дальше в эксгибиционизме и вуайеризме, я приглашаю Вас посетить{' '}
                <a href="http://www.bobtv.fr/" target="_blank" rel="noreferrer">
                    www.bobTV.fr
                </a>{' '}
                крупнейший{' '}
                <a href="http://www.bobtv.fr/" target="_blank" rel="noreferrer">
                    {' '}
                    видео чат для взрослых
                </a>{' '}
                во Франции. Мы рады Вам 24 часа из 24 и 7 дней из 7 на лучшей платформе для чат комнат во Франции. bobTV
                - это новый способ разговора о сексе, эксгибиционизма и поиска <strong>похотливых парочек</strong>{' '}
                занимающихся сексом перед вебкамерой и практикующих свингерство.
            </p>
            <p>
                Наслаждайтесь Вашим визитом как все любители подглядывать, делитесь своими фантазиями и наслаждайтесь
                сами ;-)
            </p>
            <p>Боб</p>
        </div>
    )
}

export default RuSeoInfo
